@if (!isMatItem) {
  <button mat-flat-button color="primary" (click)="openRescheduleDialog(meeting)">
    {{ 'MEETING_SCHEDULER.MEETING_ACTIONS.RESCHEDULE' | translate }}
  </button>
}

@if (isMatItem) {
  <div class="reshedule-mat-menu-item" (click)="openRescheduleDialog(meeting)">
    {{ 'MEETING_SCHEDULER.MEETING_ACTIONS.RESCHEDULE' | translate }}
  </div>
}
